import { Control, Controller, FieldErrors } from 'react-hook-form';
import { ReportFormValues } from '../reports-form-page';
import { SectionHeader } from '../../../../shared/section-header';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

interface StepExternalEmailAddressProps {
  control: Control<ReportFormValues>;
  errors: FieldErrors<ReportFormValues>;
}

export default function StepExternalEmailAddress({
  control,
  errors,
}: StepExternalEmailAddressProps) {
  return (
    <Stack gap={2} width={'100%'} alignItems={'left'}>
      <SectionHeader
        description="Please provide an external email address. This report will list all
        documents that have this email address listed as one of the owners from
        the sources data set you will choose."
      >
        External Email Address
      </SectionHeader>
      <Controller
        name="externalEmailAddress"
        control={control}
        render={({ field }) => (
          <TextField
            required
            label="External Email Address"
            sx={{ width: 400 }}
            {...field}
            error={!!errors.externalEmailAddress}
            helperText={errors?.externalEmailAddress?.message || ' '}
          />
        )}
      />
    </Stack>
  );
}
